import React from 'react'
import SkeletonElement from './SkeletonElement';

export default function SkeletonMaincard() {
  return <div className="py-10 skeletonWrapper px-9 animate-pulse">
    <SkeletonElement type="thumnail"/>
    <SkeletonElement type="text"/>
    <SkeletonElement type="text"/>
  </div>;
}
